import React from 'react'
import styles from './BookingModalSuccess.module.scss';
import { Button } from '../../Button/Button';

type TProps = {
  name: string;
  date: string;
  onRequestClose: () => void;
}
export const BookingModalSuccess: React.FC<TProps> = ({ name, date, onRequestClose }) => {
  return (
    <div>
      <div className={styles.title}>Заявка создана</div>
      <div className={styles.name}>{name}</div>
      <div className={styles.date}>{date}</div>
      <div className={styles.contact}>Организатор свяжется с вами</div>
      <div className={styles.buttonWrapper}>
        <Button text="Закрыть" onClick={onRequestClose}/>
      </div>
    </div>
  )
}
